import {
  Box, Button, Flex, Input, Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text, useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useReducer } from "react";
import { useAuth } from "../../../Hooks/useAuth";
import { api } from "../../../services/api";
import swal from "sweetalert";

const GREEN  = "#004a33";
const ORANGE = "#fc8f04";

function FormField({ label, children }) {
  return (
    <Box mb="14px">
      <Text fontSize="11px" fontWeight="700" color="gray.500" mb="5px" textTransform="uppercase" letterSpacing="0.05em">
        {label}
      </Text>
      {children}
    </Box>
  );
}

const inputProps = {
  borderRadius: "8px",
  fontSize: "14px",
  bg: "white",
  border: "1px solid rgba(0,74,51,.2)",
  _focus: { borderColor: GREEN, boxShadow: `0 0 0 1px ${GREEN}` },
};

export function EditCoupon({ couponId, handleFetchCoupons, thisCoupon }) {
  const { user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [coupon, setCoupon] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { redemption_limit: "", valid_until: "", kind: "", code: "", discount: "" }
  );

  useEffect(() => { setCoupon(thisCoupon); }, [thisCoupon]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCoupon({ [name]: value });
  };

  async function handleSave(e) {
    e.preventDefault();
    const formData = new FormData();
    formData.append("coupon[redemption_limit]", coupon.redemption_limit);
    formData.append("coupon[valid_until]", coupon.valid_until);
    formData.append("coupon[kind]", coupon.kind);
    formData.append("coupon[code]", coupon.code);
    formData.append("coupon[discount]", coupon.discount);
    const response = await api.put(`/api/v1/admin/coupons/${couponId}`, formData, {
      headers: { "access-token": user.token, client: user.client, uid: user.uid, accept: "application/json", contentType: "multipart/form-data" },
    });
    if (response.status === 200) {
      handleFetchCoupons();
      swal({ title: "Atualizado!", text: "Cupom atualizado com sucesso.", icon: "success" });
      onClose();
    } else {
      swal({ title: "Erro", text: "Algo deu errado.", icon: "error" });
      onClose();
    }
  }

  return (
    <>
      <Button
        size="xs" borderRadius="7px" px="10px" h="26px"
        bg={GREEN} color={ORANGE} fontWeight="700" fontSize="11px"
        _hover={{ opacity: 0.85 }} onClick={onOpen}
      >
        Editar
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay bg="rgba(0,0,0,.45)" backdropFilter="blur(2px)" />
        <ModalContent borderRadius="16px" overflow="hidden" mx="16px">
          <ModalHeader bg={GREEN} py="14px" px="20px" pr="44px">
            <Text fontSize="15px" fontWeight="800" color={ORANGE}>Editar Cupom</Text>
            <Text fontSize="11px" color="rgba(255,255,255,.45)" fontWeight="500" mt="1px">
              {coupon.code || `#${couponId}`}
            </Text>
          </ModalHeader>
          <ModalCloseButton color="rgba(255,255,255,.6)" _hover={{ color: "white", bg: "transparent" }} top="12px" right="14px" />
          <ModalBody px="20px" py="20px" bg="#fafbfc">
            <FormField label="Código do cupom">
              <Input value={coupon.code} name="code" onChange={handleChange} {...inputProps} />
            </FormField>
            <Flex gap="10px">
              <FormField label="Válido até">
                <Input value={coupon.valid_until} name="valid_until" type="datetime-local" onChange={handleChange} {...inputProps} />
              </FormField>
              <FormField label="Limite de uso">
                <Input value={coupon.redemption_limit} name="redemption_limit" type="number" placeholder="Qtd. máx." onChange={handleChange} {...inputProps} />
              </FormField>
            </Flex>
            <Flex gap="10px">
              <Box flex="1">
                <FormField label="Tipo de desconto">
                  <Select value={coupon.kind} name="kind" onChange={handleChange} {...inputProps}>
                    <option value="">Selecione</option>
                    <option value="fixed">Fixo (R$)</option>
                    <option value="percentage">Porcentagem (%)</option>
                  </Select>
                </FormField>
              </Box>
              <Box flex="1">
                <FormField label="Valor do desconto">
                  <Input value={coupon.discount} name="discount" type="number" placeholder="0" onChange={handleChange} {...inputProps} />
                </FormField>
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter bg="white" borderTop="1px solid rgba(0,74,51,.08)" px="20px" py="12px" gap="8px" justifyContent="flex-end">
            <Button size="sm" variant="ghost" colorScheme="gray" borderRadius="8px" onClick={onClose}>Cancelar</Button>
            <Button size="sm" bg={GREEN} color={ORANGE} borderRadius="8px" px="16px" fontWeight="700" fontSize="12px" _hover={{ opacity: 0.88 }} onClick={handleSave}>
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
